module.exports = __webpack_public_path__ + "static/media/country_hu.322899b3.webp";